import * as React from "react";
import { Select } from "antd";
import { LanguageCodes, UserPreferences } from "../../../common/Constants";
import bsLogo from "../../assets/images/settings/bs.png";
import enLogo from "../../assets/images/settings/en.png";

const { Option } = Select;

const LanguagePicker = ({
  visible,
  onLanguageChange,
  language
}: {
  visible: boolean;
  onLanguageChange: any;
  language?: string;
}) => {
  return (
    <Select
      style={{ display: visible ? "initial" : "none" }}
      value={language || UserPreferences.DEFAULT_LANGUAGE}
      onChange={onLanguageChange}
    >
      <Option value={LanguageCodes.BS}>
        <img src={bsLogo} className="language-select-logo" alt="bs-logo" />
      </Option>
      <Option value={LanguageCodes.EN}>
        <img src={enLogo} className="language-select-logo" alt="en-logo" />
      </Option>
    </Select>
  );
};

export default LanguagePicker;
